import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AppDataService, OperatorService, RiderService } from 'app/services';
import { AppComponent } from 'app/app.component';
import { MessageService } from 'primeng/api';
import { RiderUploadDocModel, RiderVehicleTypeEnum } from 'app/models';
import { SignupParams } from 'app/components/operator/operator-signup/signup-params';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';

@Component({
    selector: 'add-drivers-to-vehicle-dialog',
    templateUrl: './add-drivers-to-vehicle-dialog.component.html',
    styleUrls: ['./add-drivers-to-vehicle-dialog.component.scss',
        '../../../../../../styles/menu-sidebar.scss',
        '../../../../../../styles/style-layout.scss'
    ]
})
export class AddDriversToVehicleDialogComponent implements OnInit {
    public vehicleId: number = 0;
    @Input()
    set _vehicleId(value: number) {
        this.vehicleId = value;
    }

    public visibleAddDriversToVhicle: boolean = false;
    @Input()
    set _visibleAddDriversToVhicle(value: boolean) {
        this.visibleAddDriversToVhicle = value;
    }

    @Output() changedVisibleAddDriversToVhicleEmit = new EventEmitter<boolean>();
    changedVisibleAddDriversToVhicle(increased: any) {
        this.changedVisibleAddDriversToVhicleEmit.emit(increased);
    }

    constructor(private messageService: MessageService, public appData: AppDataService,
        public app: AppComponent, private operatorService: OperatorService, private riderService: RiderService) { }

    public riders!: any;
    public selectRider!: any;
    public selectRiderInput: string = '';
    public selectRiders: any = [];

    public isLoading: boolean = false;
    public isSearching: boolean = false;

    private timer: number = 0;

    ngOnInit(): void {
        this.searchRiders({ query: '' });
    }

    public displayRiderFn(rider: any): string {
        if (!rider) {
            return '';
        }
        return rider.UserName || `${rider.FirstName || ''} ${rider.LastName || ''}`.trim();
    }

    public cancel() {
        this.changedVisibleAddDriversToVhicle(false);
    }

    public assignDrivers() {
        this.isLoading = true;

        const dto = {
            VehicleId: this.vehicleId,
            RiderIds: this.selectRiders.map((m: any) => m.riderId)
        };

        this.riderService.addRidersToOperatorVehicle(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    this.isLoading = false;
                    return;
                }
                this.isLoading = false;
                this.messageService.add({ severity: 'success', summary: 'Drivers Added Successfully', detail: 'Drivers have been assigned to this vehicle.' });
                this.cancel();
            })
            .catch(error => {
                this.isLoading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
            });
    }

    public searchRiders(event: any) {
        /* Picking an option writes the rider object into the field, so only text counts as a query. */
        const query = typeof event?.query === 'string' ? event.query.trim() : '';
        if (this.timer) {
            window.clearTimeout(this.timer);
        }
        const delay = query ? 400 : 0;
        this.timer = window.setTimeout(() => {
            this.isSearching = true;
            const dto = { Search: query };
            const selectedIds = new Set(this.selectRiders.map((r: any) => r.riderId));

            this.riderService.searchOperatorRiders(dto, this.messageService)
                .then(data => {
                    this.isSearching = false;
                    if (!data) {
                        this.riders = [];
                        return;
                    }
                    if (!data.Success) {
                        this.riders = [];
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                        return;
                    }
                    this.riders = (data.Items || []).filter((rider: any) => !selectedIds.has(rider.RiderId));
                })
                .catch(() => {
                    this.isSearching = false;
                    this.riders = [];
                });
        }, delay);
    }

    public onSelectDriverEvent(event: MatAutocompleteSelectedEvent) {
        const rider = event.option.value;
        if (!rider?.RiderId || this.selectRiders.some((r: any) => r.riderId === rider.RiderId)) {
            this.selectRiderInput = '';
            return;
        }
        this.selectRiders.push({
            riderId: rider.RiderId,
            userName: this.displayRiderFn(rider),
            imageUrl: rider.ImageUrl
        });
        this.selectRiderInput = '';
        this.searchRiders({ query: '' });
    }

    public removeDriver(riderId: number) {
        this.selectRiders = this.selectRiders.filter((i: any) => i.riderId !== riderId);
    }
}
